import { ApiResponse, ConcernMetric, FetchAverageDaysParams } from '@/utilities/types/average.types'
import useAxios from '@/utilities/useAxios'

export const fetchAverageDaysCompletion = async ({
  userId,
  roleName,
  year,
  sinceDate,
  untilDate,
}: FetchAverageDaysParams): Promise<ConcernMetric[]> => {
  const BACKEND_URL = `${import.meta.env.VITE_DND_APP_BACKEND_URL}`

  try {
    const params: Record<string, string | number> = { userId }
    
    if (roleName) params.roleName = roleName
    if (year) params.year = year
    if (sinceDate) params.sinceDate = sinceDate
    if (untilDate) params.untilDate = untilDate

    const response = await useAxios.get<ApiResponse<ConcernMetric[]>>(
      `${BACKEND_URL}/v1/dashboard/average-days-completion-by-concern`,
      { params }
    )

    if (!response.data.success || !response.data.data) {
      throw new Error(
        `Failed to get average days completion data: ${response.data.message}`,
      )
    }

    return response.data.data
  } catch (error) {
    console.error('Error fetching average days completion:', error)
    throw error
  }
}